<div class="row menu-header pe-5">
  <div class="col-12 d-flex align-items-center" [ngClass]="isCollapsed ? 'justify-content-between' : 'justify-content-end'">
    <div class="sidebar-logo d-flex align-items-center justify-content-start" *ngIf="isCollapsed">
      <a href="/" target="_self">
        <img [src]="'./assets/images/seriella-logo-pb.png'" alt="logo">
      </a>
    </div>

    <ul>
      <li class="d-flex align-items-center">
        <div class="user-bell d-flex align-items-center">
          <a class="bell" nz-popover [nzPopoverContent]="notificationTemplate" nzPopoverPlacement="bottom">
            <i class="fi fi-rs-bell"></i>
          </a>
          <!-- <nz-badge nzStandalone [nzCount]="5"></nz-badge> -->
        </div>
        <ng-template #notificationTemplate>
          <div>
            <!-- <p>Content</p>
            <p>Content</p> -->
          </div>
        </ng-template>
      </li>
      <li class="user d-flex align-items-center mx-2">
        <div class="user d-flex align-items-center">
          <div class="user-info text-end me-2">
            <span class="title">{{ dadosUser?.nome }}</span><br />
            <span class="department fw-normal">{{ dadosUser?.grupo?.descricao }}</span>
          </div>
          <div class="user-profile d-flex align-items-center">
            <!-- <a class="img d-flex align-items-center" nz-popover [nzPopoverContent]="userTemplate" nzPopoverPlacement="bottomRight">
              <nz-avatar [nzSize]="50" nzIcon="user" nzSrc="./assets/images/icon-user.png"></nz-avatar>
              <i class="fi fi-rr-caret-down ms-2"></i>
            </a> -->
            <ng-template #userTemplate>
              <div class="popover-content">
                <a>Sair</a>
              </div>
            </ng-template>
          </div>
        </div>
      </li>
      <li class="d-flex align-items-center">
        <div class="user-theme d-flex align-items-center">
          <button nz-button nzType="primary" class="btn-primary-color border p-0" type="button" (click)="toggleTheme()">
            <span class="icone" [ngClass]="theme ? 'fs-4 carbon--sun' : 'fs-5 pb-1 octicon--moon-24'"></span>
          </button>
        </div>
      </li>
    </ul>
  </div>
</div>
